/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { quietText } from '../../../typography';
import { cardHoverLift } from '../../card-hover';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = css`
    /*
     * The surface-inverse/text-inverse tokens are the same dark-navy/white
     * pairing the rest of the site already uses for an inverted surface,
     * not a one-off colour chosen for this section.
     */
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: var(--layout-spacing-24);
    background-color: var(--colors-surface-inverse);
    color: var(--colors-text-inverse);
    border-radius: var(--effects-radius-lg);
    box-shadow: var(--effects-shadow-sm);
    ${cardHoverLift}

    .kit-lead-card-eyebrow {
        ${theme.typography.caption_highlight}
        text-transform: uppercase;
        /*
         * No token in this design system tracks letters wider than normal —
         * only tighter-than-normal steps exist — so the "letter-spaced"
         * look asked for here comes from the uppercase transform and the
         * caption size alone rather than a fabricated spacing value.
         */
        color: var(--colors-text-inverse);
        opacity: 0.7;
    }

    .kit-lead-card-value {
        display: block;
        margin-top: var(--layout-spacing-16);
        line-height: 1;
    }

    .kit-lead-card-digits {
        font-family: var(--typography-font);
        font-weight: var(--typography-weight-bold);
        font-size: var(--typography-font-size-8xl);
        color: var(--colors-brand-secondary);
    }

    /*
     * Set smaller than the digits it follows rather than at the same size, so
     * "49%" reads as one figure with a unit rather than two digits of equal
     * weight — the split this depends on is worked out in helpers/, not here.
     */
    .kit-lead-card-unit {
        font-family: var(--typography-font);
        font-weight: var(--typography-weight-bold);
        font-size: var(--typography-font-size-4xl);
        color: var(--colors-brand-secondary);
    }

    .kit-lead-card-label {
        ${theme.typography.body_large_highlight}
        display: block;
        margin-top: var(--layout-spacing-8);
        color: var(--colors-text-inverse);
    }

    .kit-lead-card-copy {
        ${quietText}
        margin-top: var(--layout-spacing-16);
        color: var(--colors-text-inverse);
        opacity: 0.7;
    }

    .kit-lead-card-genres {
        display: flex;
        flex-wrap: wrap;
        gap: var(--layout-spacing-8);
        /*
         * The list's own indent is removed rather than left to the browser, so
         * the pills start on the same edge as the copy above them; the auto top
         * margin is what holds them at the foot of the card, so it has to
         * survive that reset.
         */
        margin: auto 0 0;
        padding: var(--layout-spacing-16) 0 0;
        list-style: none;
    }

    .kit-lead-card-genre {
        ${quietText}
        padding: var(--layout-spacing-4) var(--layout-spacing-12);
        border: 0.1rem solid var(--colors-border-inverse);
        border-radius: var(--effects-radius-full);
        color: var(--colors-text-inverse);
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
